module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fb-Ge-Hc-Ia.7bc3d3ec.png";